import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class EmailTemplate extends DomainObject {
  name;
  subject;
  richText;
  lexicalState;
  annotations = [];

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      subject: observable,
      richText: observable,
      lexicalState: observable,
      annotations: observable
    });

    this.merge(other);
  }
}

export default EmailTemplate;
